"use strict";


angular.module("core")
.factory("InvoiceAttachmentService", function(
    $resource, $http, appConfig, common
) {
    var service = $resource(appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/:id/attachments/", {id: "@id"}, {
        get: {
            method: "GET",
            isArray: false
        }
    });

    var unauthenticatedService = $resource(appConfig.API_SERVER + "/invoice/copy/:uuid/attachments/", {uuid: "@uuid"}, {
        get: {
            method: "GET",
            isArray: false
        }
    });

    return {
        get: function(invoiceId) {
            return service.get({"id": invoiceId});
        },
        getCopy: function(invoiceUuid) {
            return unauthenticatedService.get({"uuid": invoiceUuid});
        },
        downloadImageAttachment: function(imageAttachmentId) {
            return $http({
                url: appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/invoice-image-attachments/" + imageAttachmentId + "/"
            }).then(function onSuccess(value) {
                common.downloadFile(value.data.base64_image, value.data.image_name);
            });
        },
        addImage: function(invoiceId, data) {
            return $http.post(
                appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/" + invoiceId + "/image-attachments/",
                data, {
                    transformRequest: angular.identity,
                    headers: {"Content-Type": undefined}
                });
        },
        getMaxImageSize: function() {
            return $http.get(appConfig.API_SERVER + "/invoice/customer/image-attachment-max-size/");
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-attachment/invoice-attachment.service.js
// module id = 435
// module chunks = 0